import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {Tab} from 'presentation/components/HeaderTabNavigation/types';
import {ExamResultsEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

const {tabs} = translations['pt-br'].privateFlow.examResults;

const EXAMS_TABS: Tab[] = [
	{
		route: ExamResultsEnum.EXAM_RESULTS,
		name: tabs.releasedResults,
		dataTagId: ExamResultsTaggingEnum.VISUALIZOU_LISTA_LIBERADOS,
	},
	{
		route: ExamResultsEnum.EXAM_RESULTS_WAITING,
		name: tabs.waitingResults,
		dataTagId: ExamResultsTaggingEnum.VISUALIZOU_LISTA_AGUARDANDO_LIBERACAO,
	},
];

export {EXAMS_TABS};
